<groundworks-modal>
  <app-paginated-modal-header
    [title]="title"
    [showNavigation]="reviewMode() && totalPendingAcrs() > 0"
    [isFirst]="isFirstAcr()"
    [isLast]="isLastAcr()"
    (previous)="previousAcr()"
    (next)="nextAcr()"
    (closed)="cancel()"
  />
  <groundworks-modal-body>
    <form [formGroup]="form">
      @if (showCapabilitiesUnavailable()) {
        <div class="alert alert-warning py-2 px-3 mb-3" role="status" data-testid="acr-capabilities-unavailable">
          Your permissions could not be checked just now, so no actions are available on this request.
          Try again in a few minutes.
        </div>
      }
      @if (awaitingAccountingPost()) {
        <div class="alert alert-info py-2 px-3 mb-3" role="status" data-testid="acr-approval-stamp">
          {{ approvalStamp() }}
        </div>
      }
      <div class="mb-3">
        <label class="form-label" for="acrType">Account Credit Request Type <span class="text-danger">*</span></label>
        <ng-select
          id="acrType"
          formControlName="acrType"
          [items]="selectableAcrTypes()"
          bindLabel="name"
          placeholder="Select account credit request type"
          [readonly]="reviewMode() && !canEdit()"
          [clearable]="!reviewMode() || canEdit()"
        ></ng-select>
      </div>
      <div class="mb-3">
        <label class="form-label" for="creditAmount">Credit Amount <span class="text-danger">*</span></label>
        <div class="input-group">
          <span class="input-group-text">$</span>
          <input
            id="creditAmount"
            type="text"
            inputmode="decimal"
            autocomplete="off"
            class="form-control text-end"
            placeholder="0.00"
            formControlName="creditAmount"
            [readonly]="reviewMode() && !canEdit()"
            [class.is-invalid]="form.controls['creditAmount'].touched && form.controls['creditAmount'].invalid"
            (blur)="onCreditAmountBlur()"
          />
        </div>
        @if (form.controls['creditAmount'].touched && form.controls['creditAmount'].invalid) {
          <div class="invalid-feedback d-block text-end">{{ creditAmountErrorMessage() }}</div>
        }
      </div>
      <div class="mb-3">
        <label class="form-label" for="notes">Notes</label>
        <textarea
          id="notes"
          class="form-control"
          rows="2"
          placeholder="Enter note for this credit."
          formControlName="notes"
        ></textarea>
        <small
          class="text-muted"
          [class.text-danger]="notesTooLong()"
          data-testid="acr-notes-counter"
        >{{ notesCharacterCount() }} / {{ maxNotesLength }}</small>
        @if (notesTooLong()) {
        <div class="text-danger small" role="alert" data-testid="acr-notes-error">
          Notes must be {{ maxNotesLength }} characters or fewer. Please shorten this note by
          {{ notesCharacterCount() - maxNotesLength }} character(s).
        </div>
        }
      </div>
      <div>
        <label class="form-label" for="documents">Upload Documentation</label>
        <app-file-dropzone
          inputId="documents"
          iconClass="bi-inbox text-primary"
          primaryText="Click or drag file to this area to upload"
          secondaryText="Support for a single or bulk upload. Maximum file size 2MB."
          (filesSelected)="onFilesSelected($event)"
        />
        @for (file of documents(); track file.name + file.lastModified; let i = $index) {
          <div class="d-flex align-items-center mt-2 px-3 py-2 border rounded-3 bg-light">
            <span class="flex-grow-1 small text-truncate">{{ file.name }}</span>
            <button
              type="button"
              class="btn-close ms-2"
              aria-label="Remove file"
              (click)="removeDocument(i)"
            ></button>
          </div>
        }
        @if (oversizedFileNames().length > 0) {
          <div class="text-danger small mt-2">
            The following files exceed the 2MB limit and were not added: {{ oversizedFileNames().join(', ') }}
          </div>
        }
      </div>
      @if (errorMessage()) {
        <div class="text-danger small mt-3">{{ errorMessage() }}</div>
      }
    </form>
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
